// Vue Router's default query parser follows the legacy application/x-www-form-urlencoded
// convention and decodes a literal `+` as a space (see `PLUS_RE` in vue-router's `parseQuery`).
export function rawQueryParam(fullPath: string, key: string): string | undefined {
  const search = fullPath.split("#")[0]?.split("?")[1];
  if (!search) {
    return undefined;
  }

  for (const pair of search.split("&")) {
    const [rawKey, rawValue = ""] = pair.split("=");
    if (decodeQueryComponent(rawKey) !== key) {
      continue;
    }
    return decodeQueryComponent(rawValue);
  }

  return undefined;
}

function decodeQueryComponent(value: string | undefined): string {
  if (!value) {
    return "";
  }
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
